import {
    makeStyles,
} from 'app/tss'

import {
    TypeIcon,
} from './notificationIcon.types'

type StylesParams = {
    isInlineIcon: boolean;
}

const useStyles = makeStyles<StylesParams>()((theme, {
    isInlineIcon,
}) => {
    return {
        container: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'start',
            alignItems: 'center',
            paddingTop: !isInlineIcon && theme.spacing(0),
            '& .MuiTypography-root': {
                padding: '0 !important',
            },
        },
        iconContainer: {
            width: '100%',
            height: '100%',
            display: 'flex',
            justifyContent: 'flex-end',
        },
        icon: {
            height: `${theme.spacing(2)} !important`,
        },
        [`${TypeIcon.INFO}`]: {
            '&&': {
                color: theme.palette.primary.main,
            },
        },
        [`${TypeIcon.WARNING}`]: {
            '&&': {
                color: theme.palette.common.yellow,
            },
        },
    }
})

export default useStyles
